import React from 'react';
import { NotificationType } from '../../../../infrastructure/types/common/common-types';
import { App } from 'antd';

interface NotificationConfig {
  title?: string;
  content?: React.ReactNode;
  closeTimeoutSec?: number;
  onClose?: () => void;
  closable?: boolean;
  footerRender?: React.ReactNode;
  key?: string;
  type?: NotificationType;
}

function useNotification() {
  const { notification } = App.useApp();

  const showNotification = ({
    title,
    content,
    closeTimeoutSec,
    footerRender,
    key,
    onClose,
    closable,
    type,
  }: NotificationConfig) => {
    notification.open({
      message: title,
      description: content,
      btn: footerRender,
      duration: closeTimeoutSec,
      closable: closable,
      onClose: onClose,
      key,
      placement: 'topLeft',
      className: 'notification-popup',
      type: type,
    });
  };

  const destroyNotification = (key: string) => {
    notification.destroy(key);
  };

  return { showNotification, destroyNotification };
}

export { useNotification };
